module.exports = __webpack_public_path__ + "static/media/screens-gameif.aa206ca0.png";